import { Component } from '@angular/core';
import { Field } from '../../field';
import { LayoutService } from '../../layout.service';
import * as g from 'src/app/globals';
import * as accounting from 'accounting';

@Component({
  selector: 'app-input-number',
  templateUrl: './input-number.component.html',
  styleUrls: ['./input-number.component.less']
})
export class InputNumberComponent extends Field {
  constructor(public layoutService: LayoutService) {
    super(layoutService);
  }

  formatterNumber(value: number): string {
    if (value === null || isNaN(value)) {
      return '';
    }

    return accounting.formatNumber(
      value,
      g.companyConfiguration.PriceDecimal,
      g.companyConfiguration.ThousandSep,
      g.companyConfiguration.DecimalSep
    );
  }
}
